(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './UsingWrapper'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./UsingWrapper'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.UsingWrapper);
    global.using = mod.exports;
  }
})(this, function (exports, _UsingWrapper) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.using = exports._ = exports.placeholder = undefined;


  /**
   * Allows to specify one or several paths to use as arguments for an immutadot function call.<br/>
   * <code>using.placeholder</code> may be used to insert a passed argument before a path argument (see second example).
   * @function
   * @memberof util
   * @param {...(Array|string)} paths The paths to use as arguments.
   * @return {Object} Returns an object with immutadot functions.
   * @example <caption>Push <code>b</code>, <code>c</code> and <code>4</code> to <code>a</code></caption>
   * const o = { nested: { a: [1], b: 2, c: 3 } }
   * using('nested.b', 'nested.c').push(o, 'nested.a', 4) // => { nested: { a: [1, 2, 3, 4], b: 2, c: 3 } }
   * @example <caption>Replace <code>a</code> by <code>a * b + 4</code> (use placeholder to send <code>updater</code> as first argument)</caption>
   * const o = { nested: { a: 2, b: 3 } }
   * using(using.placeholder, 'nested.b')
   *   .update(o, 'nested.a', (a, b, c) => a * b + c, 4) // => { nested: { a: 10, b: 3 } }
   * @since 0.1.12
   */
  var using = function using() {
    for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
      paths[_key] = arguments[_key];
    }

    return new (Function.prototype.bind.apply(_UsingWrapper.UsingWrapper, [null].concat(paths)))();
  };

  var placeholder = _UsingWrapper.UsingWrapper.placeholder;

  using.placeholder = placeholder;
  using._ = placeholder;

  exports.placeholder = placeholder;
  exports._ = placeholder;
  exports.using = using;
  exports.default = using;
});